import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { STORE } from "../lib/api";

export default function About() {
    return (
        <main data-testid="about-page">
            <section className="bg-[#0033A0] py-14 md:py-20" data-testid="about-header">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-white" data-testid="about-heading">
                        About Us
                    </h1>
                    <p className="mt-3 text-blue-100 max-w-2xl" data-testid="about-subtitle">
                        Your local destination for African and Caribbean groceries, meat, poultry and fresh produce.
                    </p>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-white" data-testid="about-story">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
                    <div>
                        <img
                            src="/assets/logo.webp"
                            alt="Freddie's Afro Caribbean Store logo"
                            className="rounded-2xl w-full shadow-lg"
                            data-testid="about-logo"
                        />
                    </div>
                    <div>
                        <h2 className="turquoise-underline font-heading text-3xl md:text-4xl font-extrabold text-slate-900 mb-8" data-testid="about-story-heading">
                            Freddie's, On Whitley Street
                        </h2>
                        <div className="space-y-4 text-slate-600 leading-relaxed" data-testid="about-story-text">
                            <p>
                                Freddie's Afro Caribbean Store is a local grocery and butcher shop at 33–35 Whitley
                                Street in Reading. We serve our community with the foods that matter — African and
                                Caribbean groceries, fresh halal meat and poultry, and fresh fruit and vegetables.
                            </p>
                            <p>
                                Our butcher counter stocks favourites like goat meat, cow foot, shaki, pomo, gizzards
                                and smoked chicken, and our shelves carry groceries, spices and international food
                                products from across Africa, the Caribbean and beyond.
                            </p>
                            <p>
                                We're open seven days a week, and PayPoint is available in store. Come in, browse the
                                aisles, and let us help you find what you're looking for.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-slate-50" data-testid="about-offer">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="turquoise-underline font-heading text-3xl md:text-4xl font-extrabold text-slate-900 mb-10" data-testid="about-offer-heading">
                        What You'll Find
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="about-offer-grid">
                        {[
                            { title: "Fresh Halal Meat", text: "Cut and prepared at our in-store butcher counter." },
                            { title: "Fruit & Vegetables", text: "Fresh produce, including tropical favourites." },
                            { title: "International Grocery", text: "African, Caribbean and international food products." },
                            { title: "PayPoint", text: "PayPoint services available in store." },
                        ].map((item) => (
                            <div key={item.title} className="card-lift bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-testid={`about-offer-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                                <span className="block h-1.5 w-10 rounded-full bg-[#40E0D0] mb-4" />
                                <h3 className="font-heading font-bold text-lg text-slate-900">{item.title}</h3>
                                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-16 md:py-20 bg-[#0033A0]" data-testid="about-cta">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white" data-testid="about-cta-heading">
                        Come and See Us
                    </h2>
                    <p className="mt-3 text-blue-100 max-w-xl mx-auto">{STORE.address}</p>
                    <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
                        <a
                            href={STORE.directionsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="about-directions-button"
                            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#40E0D0] px-8 py-3.5 font-heading font-bold text-[#0033A0] transition-colors hover:bg-[#2fd4c4]"
                        >
                            <MapPin className="h-5 w-5" />
                            Get Directions
                        </a>
                        <a
                            href={`tel:${STORE.phones[0].tel}`}
                            data-testid="about-call-button"
                            className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white px-8 py-3.5 font-heading font-bold text-white transition-colors hover:bg-white hover:text-[#0033A0]"
                        >
                            <Phone className="h-5 w-5" />
                            Call {STORE.phones[0].label}
                        </a>
                    </div>
                </div>
            </section>
        </main>
    );
}
